
import { useState, useEffect } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Lightbulb } from "lucide-react";

const quotes = [
  {
    text: "The brain is like a muscle. When it is in use we feel very good.",
    author: "Carl Sagan"
  },
  {
    text: "Train your brain to see the positive in every situation.",
    author: "Anonymous"
  },
  {
    text: "What we learn with pleasure we never forget.",
    author: "Alfred Mercier"
  },
  {
    text: "The mind is not a vessel to be filled, but a fire to be kindled.",
    author: "Plutarch"
  },
  {
    text: "The only limit to our realization of tomorrow is our doubts of today.",
    author: "Franklin D. Roosevelt"
  },
  {
    text: "Minds are like parachutes, they only function when open.",
    author: "Thomas Dewar"
  }
];

const QuotesSection = () => {
  const [quoteIndex, setQuoteIndex] = useState(0);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setQuoteIndex((prevIndex) => (prevIndex + 1) % quotes.length);
    }, 10000);
    
    return () => clearInterval(interval);
  }, []);
  
  const currentQuote = quotes[quoteIndex];
  
  return (
    <section className="py-16 px-4 md:px-8">
      <div className="max-w-4xl mx-auto">
        <Card className="border-none shadow-lg bg-gradient-to-br from-brain-purple/10 to-brain-teal/10 overflow-hidden relative">
          <CardContent className="p-8 md:p-12 text-center relative z-10">
            <div className="absolute top-6 left-1/2 transform -translate-x-1/2">
              <div className="bg-brain-purple/10 p-3 rounded-full">
                <Lightbulb size={24} className="text-brain-purple" />
              </div>
            </div>
            
            <div className="pt-12 animate-fade-in">
              <blockquote className="text-xl md:text-2xl font-medium mb-4 italic">
                "{currentQuote.text}"
              </blockquote>
              <p className="text-muted-foreground">— {currentQuote.author}</p>
            </div>
          </CardContent>
          
          {/* Background decorative elements */}
          <div className="absolute top-0 left-0 w-32 h-32 bg-brain-purple/5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-40 h-40 bg-brain-teal/5 rounded-full translate-x-1/3 translate-y-1/3"></div>
        </Card>
      </div>
    </section>
  );
};

export default QuotesSection;
